import { render } from "./HeroiconsOutlineDesktopComputer.vue?vue&type=template&id=46b297aa"
const script = {}

import exportComponent from "/data/aabpcpds/mnghaniix/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineDesktopComputer.vue"]])

export default __exports__